export default __webpack_public_path__ + "static/media/Arduino.2f1b58d6.png";